if (!customElements.get("m-countdown-timer")) {
  class MCountdownTimer extends HTMLElement {
    /* Timestamp of the next reset (default: Monday 00:00), visitor local time.
       Recomputed on every expiry so it always rolls forward on its own. */
    getNextReset(targetDay, targetHour) {
      const now = new Date();
      const result = new Date(now);
      result.setHours(targetHour, 0, 0, 0);
      let diff = (targetDay - now.getDay() + 7) % 7;
      if (diff === 0 && result.getTime() <= now.getTime()) diff = 7;
      result.setDate(result.getDate() + diff);
      return result.getTime();
    }

    connectedCallback() {
      const resetDay = parseInt(this.dataset.resetDay || "1", 10);
      const resetHour = parseInt(this.dataset.resetHour || "0", 10);
      const configured = this.dataset.time
        ? Date.parse(this.dataset.time.split(" ").join("T"))
        : NaN;

      /* Weekly when asked for explicitly, and also when the fixed end date has
         already lapsed - a passed date otherwise renders a dead all-zero timer. */
      const weekly =
        this.dataset.weeklyReset === "true" ||
        !configured ||
        Number.isNaN(configured) ||
        configured <= Date.now();

      const start = () => {
        const endTime = weekly
          ? this.getNextReset(resetDay, resetHour)
          : configured;
        if (!endTime || Number.isNaN(endTime)) return;

        new CountdownTimer(this, Date.now(), endTime, {
          callback: () => {
            if (weekly) start();
          },
        });

        if (endTime > Date.now()) {
          this.classList.remove("hidden");
          this.classList.remove("m:hidden");
        }
      };

      start();
    }
  }

  customElements.define("m-countdown-timer", MCountdownTimer);
}
